import type { NotificationTag } from './NotificationPreferences';

export interface Notification {
	title: string;
	description: string;
	type: 'default' | 'success' | 'error' | 'warning' | 'info';
}

export interface NotificationItem {
	id: string;
	subject: string;
	body: string;
	createdAt: string;
	tags: string[];
}

export type NotificationFilter = 'all' | NotificationTag;

export const TAG_URL_MAP: Record<string, { be: string; lux: string }> = {
	uzzer: {
		be: import.meta.env.VITE_AUTH_URL || '',
		lux: import.meta.env.VITE_AUTH_LUX_URL || '',
	},
	beneficiary: {
		be: import.meta.env.VITE_MYMONIZZE_URL || '',
		lux: import.meta.env.VITE_MYMONIZZE_LUX_URL || '',
	},
	employer: {
		be: import.meta.env.VITE_CLIENT_URL || '',
		lux: import.meta.env.VITE_CLIENT_LUX_URL || '',
	},
	partner: {
		be: import.meta.env.VITE_PARTNER_URL || '',
		lux: import.meta.env.VITE_PARTNER_LUX_URL || '',
	},
};

export function getNotificationUrl(tags: string[]): string | null {
	const isLux = window.location.host.includes('up-luxembourg');
	for (const tag of tags) {
		const urls = TAG_URL_MAP[tag];
		if (urls) {
			const url = isLux ? urls.lux : urls.be;
			return url || null;
		}
	}
	return null;
}
